var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 10H2.6C2.03995 10 1.75992 10 1.54601 10.109C1.35785 10.2049 1.20487 10.3578 1.10899 10.546C1 10.7599 1 11.0399 1 11.6V17.4C1 17.9601 1 18.2401 1.10899 18.454C1.20487 18.6422 1.35785 18.7951 1.54601 18.891C1.75992 19 2.03995 19 2.6 19H7M7 19H13M7 19L7 6.6C7 6.03995 7 5.75992 7.10899 5.54601C7.20487 5.35785 7.35785 5.20487 7.54601 5.10899C7.75992 5 8.03995 5 8.6 5H11.4C11.9601 5 12.2401 5 12.454 5.10899C12.6422 5.20487 12.7951 5.35785 12.891 5.54601C13 5.75992 13 6.03995 13 6.6V19M13 19H17.4C17.9601 19 18.2401 19 18.454 18.891C18.6422 18.7951 18.7951 18.6422 18.891 18.454C19 18.2401 19 17.9601 19 17.4V2.6C19 2.03995 19 1.75992 18.891 1.54601C18.7951 1.35785 18.6422 1.20487 18.454 1.10899C18.2401 1 17.9601 1 17.4 1H14.6C14.0399 1 13.7599 1 13.546 1.10899C13.3578 1.20487 13.2049 1.35785 13.109 1.54601C13 1.75992 13 2.03995 13 2.6V6",
    stroke: "#F9F6F0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.810deeddc41783beefc34a6150f6152a.svg";
export { ForwardRef as ReactComponent };